export enum AlarmType {
  RedAlarms = 'redAlarms',
  TimedAlerts = 'timedAlerts',
}

export interface AlarmsProps {
  view: AlarmType;
}
